var React = require('react');

function CirclePlusInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18.5","r":"18","fill":"#00114D","key":0}),React.createElement("line",{"x1":"13","y1":"18.5","x2":"23","y2":"18.5","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"18","y1":"23.5","x2":"18","y2":"13.5","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

CirclePlusInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 37","fill":"none"};

module.exports = CirclePlusInline;

CirclePlusInline.default = CirclePlusInline;
